import { useEffect, useRef } from 'react';
import useSessionManager from '@afosto/auth-react/useSessionManager';
import LogRocket from 'logrocket';

export default () => {
  const sessionManager = useSessionManager();
  const sessionManagerRef = useRef(sessionManager);

  useEffect(() => {
    sessionManagerRef.current = sessionManager;
  });

  useEffect(() => {
    const { current: currentSessionManager } = sessionManagerRef;

    const handleSession = () => {
      if (currentSessionManager?.user) {
        const { tenant, client, scopes } = currentSessionManager?.tokenMetadata ?? {};

        LogRocket.identify(currentSessionManager.user.id, {
          ...(currentSessionManager.user || {}),
          tenant,
          client,
          scopes,
        });
      }
    };

    if (currentSessionManager) {
      currentSessionManager.registerSessionHandler(handleSession);
    }

    return () => {
      if (currentSessionManager) {
        currentSessionManager.unregisterSessionHandler(handleSession);
      }
    };
  }, []);
};
